import authLanguages from './authLanguages';
import { TLanguage } from '../models/languages.type';

const getAuth0Options = (redirectUrl: string, language: TLanguage): Auth0LockConstructorOptions => ({
  container: 'auth0_login',
  allowedConnections: [process.env.REACT_APP_AUTH0_CONNECTION!],
  auth: {
    redirectUrl: process.env.REACT_APP_AUTH0_REDIRECT_URL,
    responseType: 'token',
    params: {
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email',
      appState: redirectUrl
    }
  },
  theme: {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    logo: `${process.env.PUBLIC_URL}/saas1.svg`,
    primaryColor: '#e91e63'
  },
  rememberLastLogin: false,
  allowShowPassword: true,
  avatar: null,
  languageDictionary: authLanguages[language]
});

export default getAuth0Options;
